/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  function configurer(){
    
      $('.menu-trigger').on('click', function() {
          $(this).toggleClass('menu-open');
          $('.main-menu-wrapper').toggleClass('visible');
      });

      $('.front-blog-slider').slick({
        slidesToShow: 2,
        infinite: false,
        arrows: false,
        dots: false,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
      });

      $('.histoire-slider').slick({
        slidesToShow: 4,
        infinite: false,
        arrows: true,
        dots: false,
        appendArrows: '.histoire-slider-nav',
        responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
      });

      $('.gallery-slider').slick({
        slidesToShow: 1,
        infinite: true,
        arrows: true,
        fade: true,
        adaptiveHeight: true
      });

      var lastScrollTop = 0;

      $(window).on('scroll', function() {
            
        scrollPosition = $(this).scrollTop();
            
            if (scrollPosition >= 10) {
              $('header .header-wrapper').addClass('fixed');
            }else {
              $('header .header-wrapper').removeClass('fixed');
            }

      });

      //Blog

      $('.filter-section.toggle p.title').on('click', function(){

        var current = $(this).parent();

        current.toggleClass('closed');

        if(current.hasClass('closed')){
          current.find('.list ul').addClass('hidden');

          setTimeout(function() {
            current.find('.list').slideToggle();
          },400);    
        }else {
          current.find('.list').slideToggle();

          setTimeout(function() {
            current.find('.list ul').removeClass('hidden');
          },400);    
          
        }            

      });

      //Filtre - Expertise
      $('#filter-expertise li').on('click', function() {

        resetPostsFilter();

        var expertise_id = $(this).attr('data-id');        

        if($(this).hasClass('active')){
          $('#filter-expertise li.active').removeClass('active');

          resetExpertiseFilter();
          //resetPostsFilter();

          ShowGeneralPostsList();

        }else {

          $('#filter-expertise li.active').removeClass('active');
          $(this).toggleClass('active');

          $('#filter-lois-field').val(expertise_id);

          HideGeneralPostsList();

          ShowExpertisePostsList();
        }      

      });

      //Filtre - Category
      $('#filter-category li').on('click', function() {

        resetExpertiseFilter();

        var catId = $(this).attr('data-id');

        var currentSelectedCat = $('#filter-category-field').val();


        if($(this).hasClass('active')){
          //Remove
          currentSelectedCat = currentSelectedCat.split(',');
          
          //Remove empty element
          var currentSelectedCat = currentSelectedCat.filter(function (el) {
            return el != null && el != "";
          });

          var currentIdIndex = $.inArray(catId, currentSelectedCat);

          currentSelectedCat.splice(currentIdIndex, 1);

          currentSelectedCat = currentSelectedCat.join();

          if(currentSelectedCat == ''){
           $('#filter-category-field').val(""); 
          }else {
            $('#filter-category-field').val(currentSelectedCat+","); 
          }

          $('#filtre-category li[data-cat-id="'+catId+'"]').removeClass('active');

        }else {
          //Add
          $('#filter-category-field').val(currentSelectedCat+catId+',');
          $('#filtre-category li[data-cat-id="'+catId+'"]').addClass('active');

        }

        $(this).toggleClass('active');

        if($('#filter-category li.active').length == 0){
          ShowGeneralPostsList();
          hideFilteredList();
        }else {
          HideGeneralPostsList();
          ShowBlogPostsList();
        }

        return false;
      });

      //Filtre - Reset
      $('.filter-section.reset').on('click', function() {

        ShowGeneralPostsList();

        hideFilteredList();

      });

      $('.mobile-filter-trigger').on('click', function() {
          $('.filters-section').slideToggle();
      });

      //Emploi trigger
      $('#emploi-trigger').on('click', function() {

        $(this).toggleClass('active');

        $('#all-posts').css('opacity', 0);

        var current = $(this);

        setTimeout(function() {

          if(current.hasClass('active')) {
            $('#all-posts .blog-post.emploi').show();
          }else {
            $('#all-posts .blog-post.emploi').hide();
          }

          $('#all-posts').css('opacity', 1);

        }, 800);

        

      });

      if($(window).width() >= 992 && $('#index').length > 0) {
        var distance = $('#index').offset().top-100,
            $window = $(window);

        $window.scroll(function() {
            if ( $window.scrollTop() >= distance ) {
              $('#index').addClass('fixed');
            }else {
              $('#index').removeClass('fixed');
            }
        });
      }


      if($(window).width() <= 992) {

        $(window).on('scroll', function() {
          $('#single-publication-header .right-panel').removeClass('visible');
          $('.panel-trigger').removeClass('visible');
        });

      }

      if($(window).width() <= 768) {

        var divs = $("#all-posts .blog-post");
        for(var i = 0; i < divs.length; i+=4) {
          divs.slice(i, i+4).wrapAll("<div class='page'></div>");
        }

        $('#all-posts').slick({
          infinite: false
        });

        $('#all-posts').append('<p class="first-slide">Première page</p>')

        $('#all-posts .first-slide').on('click', function() {
            $('#all-posts').slick('slickGoTo', 0);
        });

      }

      $(".print").click(function() {
        window.print();
      });

      $('.panel-trigger').on('click', function() {

        $('.right-panel').toggleClass('visible');
        $(this).toggleClass('visible');

      });

      $('.accordeon .title-wrapper').on('click', function() {
        $(this).parent().toggleClass('open');
        $(this).parent().find('.content').slideToggle();        
      });

      //Anchor animations
      $('a[href^="#"]').on('click touchend', function() {
        var the_id = $(this).attr("href");
        if(the_id !== '#') {

          $('html, body').animate({
            scrollTop: $(the_id).offset().top - 100
          }, 'slow');

        }
        return false;

      });

      //Gallery - Single publications
      $('.section-gallery').each(function() {

        $(this).find('.gallery-slider-thumbnail img').on('click touch', function() {

          var sliderId = $(this).attr('data-section');
          var imageId = $(this).attr('data-id');

          $('.section-gallery-lightbox[data-id="'+sliderId+'"]').addClass('-visible');

          alert(imageId);

          $('.section-gallery-lightbox[data-id="'+sliderId+'"]').find('.gallery-slider').slick('slickGoTo', imageId);

        });

      });
  }

  function hideEmploiTrigger() {
    $('.filter-section.emploi').addClass('hidden');
  }
  function showEmploiTrigger() {
    $('.filter-section.emploi').removeClass('hidden');
  }

  function resetExpertiseFilter() {
    $('#filtered-list-lois .blog-post').css('opacity', '0');
    $('#filter-expertise li.active').removeClass('active');
    $('#filter-lois-field').val('');

    setTimeout(function() {      
      $('#filtered-list-lois').slideUp();
    }, 400);

  }

  function resetPostsFilter() {
    $('#filtered-list-post .blog-post').css('opacity', '0');
    $('#filter-category li.active').removeClass('active');
    $('#filter-category-field').val('');
    
    setTimeout(function() {      
      $('#filtered-list-post').slideUp();
    }, 400);
    
  }

  function HideGeneralPostsList() {

    $('#all-posts .blog-post').css('opacity', '0');

    hideEmploiTrigger();

    setTimeout(function() {
      $('#all-posts').slideUp();
    }, 400);

  }

  function ShowGeneralPostsList() {

    $('#all-posts').slideDown();

    showEmploiTrigger();

    setTimeout(function() {      
      $('#all-posts .blog-post').css('opacity', '1');
    }, 400);

  }

  function ShowExpertisePostsList() {

    var visibleCount = 0;
    $('#filtered-list-lois').slideDown();
    $('#filtered-list-lois').css('opacity', '0');
    $('#filtered-list-lois .no-result').fadeOut();

    var selectedExpertiseId = $('#filter-lois-field').val();

    //Filtre des posts
    $('#filtered-list-lois .blog-post').each(function() {


      var current = $(this);

      current.hide();

      setTimeout(function() {

        var expertiseId = current.attr('expertise-id');

        expertiseId = expertiseId.split(',');

        if(jQuery.inArray(selectedExpertiseId, expertiseId) !== -1){
          current.show();
          visibleCount++;
        }

        $('#filtered-list-lois').css('opacity', '1');
      }, 400);

    });

    setTimeout(function() {   

      if(visibleCount == 0){
        $('#filtered-list-lois .no-result').fadeIn();
      }

      $('#filtered-list-lois .blog-post').css('opacity', '1');
    }, 600);

  }

  function ShowBlogPostsList() {

    var visibleCount = 0;
    $('#filtered-list-post').slideDown();
    //$('#filtered-list-post').css('opacity', '0');
    $('#filtered-list-post .no-result').fadeOut();

    var selectedCatIds = $('#filter-category-field').val();

    if(selectedCatIds){
      selectedCatIds = selectedCatIds.split(',');
    

      //Filtre des posts
      $('#filtered-list-post .blog-post').each(function() {

        var postCats = $(this).attr('data-cat');

        postCats = postCats.split(',');         

        selectedCatIds = selectedCatIds.filter(Boolean);

        postCats = postCats.filter(Boolean);

        postCats = postCats.sort();
        selectedCatIds = selectedCatIds.sort();

        
        var current = $(this);

        current.hide();

        setTimeout(function() {

          if(checkElementsinArray(selectedCatIds, postCats) == true){
              
              current.show();
            visibleCount++;
          }

          $('#filtered-list-post').css('opacity', '1');
        }, 400);

      });

      setTimeout(function() {   

        if(visibleCount == 0){
          $('#filtered-list-post .no-result').fadeIn();
        }

        $('#filtered-list-post .blog-post').css('opacity', '1');
      }, 600);

    }

  }


  function checkElementsinArray(fixedArray,inputArray)
  {
      var fixedArraylen = fixedArray.length;
      var inputArraylen = inputArray.length;
      if(fixedArraylen<=inputArraylen)
      {
          for(var i=0;i<fixedArraylen;i++)
          {
              if(!(inputArray.indexOf(fixedArray[i])>=0))
              {
                  return false;
              }
          }
      }
      else
      {
          return false;
      }
      return true;
  }

  function hideFilteredList() {
    $('#filtered-list-lois .blog-post').css('opacity', '0');
    $('#filter-expertise li.active').removeClass('active');
    $('#filter-lois-field').val('');

    $('#filtered-list-post .blog-post').css('opacity', '0');
    $('#filter-category li.active').removeClass('active');
    $('#filtered-list-post').val('');

    setTimeout(function() {      
      $('#filtered-list-lois').slideUp();
      $('#filtered-list-post').slideUp();
    }, 400);

    ShowGeneralPostsList();
  }


  window.onload = configurer;

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
